
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class Notification extends Vue {
  @Prop({ type: Boolean, required: true }) public model!: boolean;
  @Prop(Boolean) public close!: boolean;
  @Prop({ type: Number, default: 3000 }) public timeout!: number;
  @Prop({ type: String, default: 'red' }) public color!: string;
  @Prop({ type: String, default: 'Error' }) public text!: string;
  private isVisible = false;

  @Watch('model', { immediate: true })
  private watchToModel() {
    this.isVisible = this.model;
  }

  @Watch('isVisible', { immediate: true })
  private watchToIsVisible() {
    if (!this.isVisible) {
      this.$emit('change');
    }
  }
}
